import React from 'react';
import { View, StyleSheet } from 'react-native';
import StatusBar from 'design-system/StatusBar';
import { AppView, Indicator } from 'design-system';
const InvestLoadingView = () => (<AppView>
    <StatusBar animated barStyle="dark-content"/>
    <View style={styles.container}>
      <Indicator dark/>
    </View>
  </AppView>);
export default InvestLoadingView;
const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
});
